import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dr-input-textarea',
  templateUrl: './input-textarea.component.html',
  styleUrls: ['./input-textarea.component.scss']
})
export class InputTextareaComponent implements OnInit {

  public comment: string;

  constructor() { }

  ngOnInit() {
  }

}
